import { MapContainer, TileLayer, CircleMarker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { Link } from 'react-router-dom';
import { pct, phoneApproval, usd } from '../../lib/feasibilityLabels';
import { STREET_TILES } from '../../lib/mapTiles';
import type { Approval, LandUpsideRow } from '../../types/feasibility';

const COLOR: Record<Approval, string> = {
  by_right: '#047857', permit: '#b45309', unclear: '#0369a1', not_allowed_now: '#c2410c',
  not_allowed: '#6b7280', no_rules: '#9ca3af', no_zone: '#9ca3af',
};

export default function UpsideMap({ rows }: { rows: LandUpsideRow[] }) {
  const pins = rows.filter((r) => r.master_properties?.latitude != null && r.master_properties?.longitude != null);
  if (pins.length === 0) return <p className="text-sm text-gray-600">None of these properties has a map pin.</p>;
  const lat = pins.reduce((s, r) => s + Number(r.master_properties.latitude), 0) / pins.length;
  const lng = pins.reduce((s, r) => s + Number(r.master_properties.longitude), 0) / pins.length;
  return (
    <div>
      <div className="h-[60vh] min-h-[320px] overflow-hidden rounded-lg border">
        <MapContainer center={[lat, lng]} zoom={10} className="h-full w-full">
          <TileLayer {...STREET_TILES} />
          {pins.map((r) => (
            <CircleMarker key={`${r.property_id}-${r.use_family}`} radius={7}
              center={[Number(r.master_properties.latitude), Number(r.master_properties.longitude)]}
              pathOptions={{ color: COLOR[r.approval], fillOpacity: 0.7 }}>
              <Popup>
                <Link to={`/data-hub/${r.property_id}`}>{r.master_properties.address ?? 'No address'}</Link>
                {/* FZ-FIX2: the use that earned the answer, and 'only' for a pad - the phone line's own words */}
                <div>{phoneApproval(r)}</div>
                <div>{r.upside !== null ? `Upside ${usd(r.upside)} (${pct(r.upside_share)})` : `A developer could pay ${usd(r.residual_value)}`}</div>
              </Popup>
            </CircleMarker>
          ))}
        </MapContainer>
      </div>
      <p className="mt-1 text-xs text-gray-500">{`${pins.length} of ${rows.length} on this page have a map pin.`}</p>
    </div>
  );
}
